import {
  IDynamicDiplayView,
  IDynamicSection
} from '@components/widgets/dynamic-display';
import { EnhancedDisplayType } from '@components/widgets/dynamic-display/EnhancedDisplay';

import { PolicyMarineResponse } from '../types';

export function buildMarineDetailsView(
  data: PolicyMarineResponse[],
  policyCurrencySymbol: string
): IDynamicDiplayView {
  return {
    name: 'PolicyMarineDetails',
    sections: data.map(
      (item): IDynamicSection => ({
        name: 'MarineDetails',
        title: 'Marine Details',
        properties: {
          matter: {
            multiline: false,
            value: item.matter?.title || '',
            name: 'matter',
            title: 'Matter',
            fullLine: true
          },
          description: {
            multiline: false,
            value: item.description || '',
            name: 'description',
            title: 'Description',
            fullLine: true
          },
          vesselName: {
            multiline: false,
            value: item.vessalName || '',
            name: 'vesselName',
            title: 'Vessel Name'
          },
          vesselAge: {
            multiline: false,
            value: item.vessalAge?.toString() || '',
            name: 'vesselAge',
            title: 'Vessel Age'
          },
          departure: {
            multiline: false,
            value: item.departureFrom || '',
            name: 'departureFrom',
            title: 'Departure'
          },
          destination: {
            multiline: false,
            value: item.departureTo || '',
            name: 'departureTo',
            title: 'Destination'
          },
          transportationVia: {
            multiline: false,
            value: item.transportationVia || '',
            name: 'via',
            title: 'Transportation Via'
          },
          survey: {
            multiline: false,
            value: item.survey || '',
            name: 'survey',
            title: 'Survey'
          },
          cargoContract: {
            multiline: false,
            value: item.cargoContract || '',
            name: 'cargoContract',
            title: 'Cargo Contract'
          },
          bank: {
            multiline: false,
            value: item.bank || '',
            name: 'bank',
            title: 'Bank'
          },
          sumPerShipmentCurrency: {
            multiline: false,
            value: item.sumPerShipmentCurrency?.title || '',
            name: 'sumPerShipmentCurrency',
            title: 'Sum Per Shipment (Currency)'
          },
          sumPerShipment: {
            multiline: false,
            value: item.sumPerShipment?.toString() || '',
            type: EnhancedDisplayType.RoundedCurrency,
            currencySymbol: item.sumPerShipmentCurrency?.symbol || '',
            name: 'sumPerShipment',
            title: 'Sum Per Shipment'
          },
          sumPerShipmentPolicyCurrency: {
            multiline: false,
            value: item?.sumPerShipmentPolicyCurrency?.toString() || '',
            type: EnhancedDisplayType.RoundedCurrency,
            currencySymbol: policyCurrencySymbol,
            name: 'sumPerShipmentPolicyCurrency',
            title: 'Sum Per Shipment (Policy Currency)',
            breaksRow: true
          },
          lcNumber: {
            multiline: false,
            value: item.lcNumber || '',
            name: 'lcNumber',
            title: 'LC Number'
          },
          lcIssueDate: {
            multiline: false,
            value: item.lcIssueDate || '',
            type: EnhancedDisplayType.Date,
            name: 'lcIssueDate',
            title: 'LC Issue Date'
          },
          claimsPayableBy: {
            multiline: false,
            value: item.claimsPayableBy || '',
            name: 'claimsPayableBy',
            title: 'Claims Payable by'
          },
          loading: {
            multiline: false,
            value: item.loading?.toString() || '',
            type: EnhancedDisplayType.RoundedPercentage,
            name: 'loading',
            title: 'Loading'
          },
          remarks: {
            multiline: false,
            value: item.remarks || '',
            name: 'remarks',
            title: 'Remarks',
            fullLine: true
          }
        }
      })
    )
  };
}
